// extracted by mini-css-extract-plugin
export default {"input":"name_input__BT-kN","errorBorder":"name_errorBorder__oKHfu","p":"name_p__QQolP"};